import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Injector,
    Input,
    OnDestroy,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { RoleModel } from '@fi-app/role/role.model';
import { CustomButtonModel } from '@fi-app/core/custom-button.model';
import { ExtendedRoleRightModel } from '@fi-app/role/extended-role-right.model';
import { ApplicationSettingsModel } from '@fi-app/role/application-settings.model';
import { Animations } from '@fi-shared/utils/animations';
import { RoleHelperService } from '../services/role-helper.service';
import { ILightWeightObject } from '@fi-shared/models';
import { Subject } from 'rxjs';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';
import { AbstractControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';
import { isDefined } from '@fi-shared/utils';

export enum RolePageLayout {
    RoleModules,
    RoleExtendedRights,
}

@Component({
    selector: 'fi-role-new-layout',
    templateUrl: './role-new-layout.component.html',
    styleUrls: ['./role-new-layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [Animations.enterState(200)],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-role-new-layout' },
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: RoleNewLayoutComponent,
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: RoleNewLayoutComponent,
        },
    ],
    standalone: false,
})
export class RoleNewLayoutComponent extends ControlValueAccessorValidatorBase<RoleModel> implements OnDestroy {
    @Input() allRoles: ILightWeightObject[];
    @Input() customButtons: CustomButtonModel[];
    @Input() extendedRoleRight: ExtendedRoleRightModel;
    @Input() roleApplicationSettingGroups: {
        [key: string]: ApplicationSettingsModel[];
    };
    @Input() isEditMode: boolean;
    @Input() roleLayout = RolePageLayout.RoleModules;
    @Output() onSaveButtonClick = new EventEmitter<void>();
    @Output() onBackButtonClick = new EventEmitter<void>();

    @Output() onRoleLayoutChange = new EventEmitter<RolePageLayout>();

    RolePageLayout = RolePageLayout;

    get role(): RoleModel {
        return this.ngModel;
    }

    constructor(
        injector: Injector,
        private roleHelperService: RoleHelperService,
    ) {
        super(injector);
    }

    setRoleLayout(layout: RolePageLayout) {
        this.roleLayout = layout;
        this.onRoleLayoutChange.emit(this.roleLayout);
    }

    isCurrentRoleLayout(layout: RolePageLayout) {
        return this.roleLayout === layout;
    }

    save() {
        this.onSaveButtonClick.emit();
    }

    doValidate(c: AbstractControl): ValidationErrors {
        return {
            roleNoName: this.role.Names.every((name) => name.Value?.trim().length < 1),
        };
    }

    back() {
        this.onBackButtonClick.emit();
    }

    private ngOnDestroy$ = new Subject<void>();
    public ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
        this.roleHelperService.setRoleDataChanged(false);
    }
}
